var map = {
	"./7z.svg": 285,
	"./aac.svg": 286,
	"./ai.svg": 287,
	"./archive.svg": 288,
	"./arj.svg": 289,
	"./audio.svg": 290,
	"./avi.svg": 291,
	"./css.svg": 292,
	"./csv.svg": 293,
	"./dbf.svg": 294,
	"./doc.svg": 295,
	"./dwg.svg": 296,
	"./exe.svg": 297,
	"./fla.svg": 298,
	"./flac.svg": 299,
	"./gif.svg": 300,
	"./html.svg": 301,
	"./iso.svg": 302,
	"./jpg.svg": 303,
	"./js.svg": 304,
	"./json.svg": 305,
	"./mdf.svg": 306,
	"./mp2.svg": 307,
	"./mp3.svg": 308,
	"./mp4.svg": 309,
	"./mxf.svg": 310,
	"./nrg.svg": 311,
	"./pdf.svg": 312,
	"./png.svg": 313,
	"./ppt.svg": 314,
	"./psd.svg": 315,
	"./rar.svg": 316,
	"./rtf.svg": 317,
	"./stl.svg": 318,
	"./svg.svg": 319,
	"./text.svg": 320,
	"./tiff.svg": 321,
	"./txt.svg": 322,
	"./unknown.svg": 145,
	"./video.svg": 323,
	"./wav.svg": 324,
	"./wma.svg": 325,
	"./xls.svg": 326,
	"./xml.svg": 327,
	"./zip.svg": 328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 284;